const DEFAULT_MAX_LENGTH = 100;

export default function MaxLengthText({
  text,
  maxLength = DEFAULT_MAX_LENGTH,
}: {
  text: string;
  maxLength?: number;
}) {
  return <span>{text.substring(0, maxLength)}...</span>;
}
